<template>
    <div class="report-footer">
        <hr class="break-before-always">
        <div class="row">
            <div class="col-lg-12">
                <h2>Besten Dank für Ihr Interesse</h2>
                <p>Gerne unterstützen wir Sie bei der Umsetzung der Handlungsempfehlungen.</p>
            </div>
        </div>
        <div v-if="coach">
            <df-coach :data="coach" short/>
            <div class="row">
                <div class="col-lg-8 col-xl-7 offset-lg-1 user-info-list report-footer__user-info">
                    <table class="no-border no-strip skills">
                        <tbody class="no-border-x no-border-y">
                        <tr>
                            <td class="icon"><span class="mdi mdi-pin"></span></td>
                            <td class="item">Region</td>
                            <td class="value">{{ coach.region }}</td>
                        </tr>
                        <tr>
                            <td class="icon"><span class="mdi mdi-globe-alt"></span></td>
                            <td class="item">Sprachen</td>
                            <td class="value">{{ languages }}</td>
                        </tr>
                        <!--
                        <tr>
                            <td class="icon"><span class="mdi mdi-graduation-cap"></span></td>
                            <td class="item">Erfasste Solutions</td>
                            <td>{{ data.solutions }}</td>
                        </tr>
                        -->
                        <!--
                        <tr>
                            <td class="icon"><span class="mdi mdi-assignment-alert"></span></td>
                            <td class="item">Durchgeführte<br>Assessments</td>
                            <td>{{ data.assessments }}</td>
                        </tr>
                        -->
                        <tr v-if="coach.specialization">
                            <td class="icon"><span class="mdi mdi-star-circle"></span></td>
                            <td class="item">Spezialisierung</td>
                            <td class="value">{{ coach.specialization.join(', ') }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-lg-3 mt-sm-5 mt-lg-2">
                    <span class="title">{{ coach.company }}</span>
                    <p>
                        {{coach.companyStreet}}<br>
                        {{coach.companyCountry}}-{{coach.companyPostcode}} {{coach.companyLocation}}<br>
                        <br>
                        {{ coach.companyPhone }}<br>
                        <a :href="coach.companyWebsite" target="_blank">{{ coach.companyWebsite }}</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="mt-5">
            <h3 class="pt-5">Nach dem Check ist vor dem Check</h3>
            <p>Das Bewertungsraster der Fragen wird jährlich durch eine Expertengruppe auf den neuesten Stand der Dinge gebracht. Es lohnt sich deshalb jedes Jahr erneut einen solchen Check durchführen zu lassen.</p>
        </div>
    </div>
</template>

<script>
    import User from '../../../../models/User';
    import Assessment from '../../../../models/Assessment';

    export default {
        props: {
            assessment: {
                type: Assessment,
                required: true,
            },
        },

        computed: {
            languages() {
                return this.coach ? this.coach.languages.map(k => User.LanguagesMap[k]).join(', ') : '';
            },
        },

        asyncComputed: {
            coach: vm => vm.assessment.getCoach(),
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .report-footer {
        &__user-info {
            @media screen and (min-width:1350px) {
                margin-left: 150px;
            }
        }
    }
</style>
